import { FieldInputProps } from 'react-final-form'

/**
 * @description if is an object return input.value.value or input.value
 */
export const getValue = (
  input: FieldInputProps<string, HTMLElement>
): {
  instructions_is_active: boolean
  instructions: string
} => {
  if (typeof input.value === 'object') {
    const object = input.value as {
      instructions_is_active: boolean
      instructions: string
    }
    return object
  }
  return {
    instructions_is_active: false,
    instructions: '',
  }
}
